export default {
	'ddc.link.generic': [
		// remove these events so client does not duplicate tagging coming from MyCars links clicks
		{
			insertion: 'unshift',
			logic: ({ eventData }) =>
				['button-save', 'button-trackPrice'].includes(
					eventData?.attributes?.['data-testid']
				) ||
				eventData?.attributes?.['data-cy'] === 'get-notified-button'
		}
	],
	widgetUserEvent: [
		{
			logic: {
				'eventData.action': 'clicked',
				'eventData.element': 'Save button',
				'eventData.result': 'Vehicle saved'
			},
			payload: {
				category: 'engagement',
				action: 'link click',
				label: 'save vehicle',
				vehicles: '[[fn.getVehicleArray()]]',
				inventory_type: '[[lookup.eventData.inventoryType]]',
				site_events: {
					save_vehicle: true
				},
				site_provider: 'ddc'
			}
		},
		{
			logic: {
				'eventData.action': 'clicked',
				'eventData.result': 'Email Signup for Price Alert Notification'
			},
			payload: {
				vehicles: '[[fn.getVehicleArray()]]',
				customer_lead_type: 'receive updates',
				customer_lead_level: 'partial: email',
				site_events: {
					receive_updates: true
				},
				site_provider: 'ddc'
			}
		}
	]
};
